type Request = { fingerprint:string; key:string };
const storageKey=(projectId:string)=>`vgen.scenario-request:${projectId}`;
const pending=new Map<string,Request>();
/** Reuse uncertain submissions, including after reopening the same project. */
export function scenarioRequestKey(projectId:string,payload:unknown){
  const fingerprint=JSON.stringify(payload);
  let saved=pending.get(projectId);
  try{saved=JSON.parse(localStorage.getItem(storageKey(projectId))??'null')??saved;}catch{/* memory fallback */}
  if(saved?.fingerprint===fingerprint)return saved.key;
  const next={fingerprint,key:crypto.randomUUID()};pending.set(projectId,next);
  try{localStorage.setItem(storageKey(projectId),JSON.stringify(next));}catch{/* memory fallback */}
  return next.key;
}
export function clearScenarioRequest(projectId:string,key:string){
  if(pending.get(projectId)?.key===key)pending.delete(projectId);
  try{const saved=JSON.parse(localStorage.getItem(storageKey(projectId))??'null') as Request|null;if(saved?.key===key)localStorage.removeItem(storageKey(projectId));}catch{/* accepted request is safe to replay */}
}
